import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

class Transfers {
  constructor () {
    this.baseURL = 'transfers'
  }

  async initiateExpediteTransfer (payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).post(`/initiate-expedite`, payload)
      return result?.data
    }
    catch (error) {
      CError(`Could not initiate expedite transfer for client id ${payload.clientId} on V2 API`, error)
      throw error
    }
  }

  async initiateDebitTransfer (payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).post(`/initiate-debit-regular`, payload)
      return result?.data
    }
    catch (error) {
      CError(`Could not initiate debit transfer for client id ${payload.clientId} on V2 API`, error)
      throw error
    }
  }

  async initiateRegularTransfer (payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).post(`/initiate-regular`, payload)
      return result?.data
    }
    catch (error) {
      CError(`Could not initiate regular transfer on V2 API`, error)
      throw error
    }
  }
}

export default Transfers
